import Firebase from "firebase/app";
import ReactGA from "react-ga";
import slugify from "slugify";

import { prepareDocForCreate } from "./helpers/firestoreHelpers";

const addCountry = (country_name, isSchengen) => {
  ReactGA.event({
    category: "Post",
    action: "Create post",
  });

  //   values.slug = slugify(values.title, { lower: true });
  //   values._likeCount = 0;
  const values = {
    country_name,
    active: true,
    isSchengen,
  };
  prepareDocForCreate(values);
  return Firebase.firestore()
    .collection("country")
    .add(values)
    .then(() => country_name)
    .catch((error) => {
      console.log(error);
      alert(`Whoops, couldn't create the post: ${error.message}`);
    });
};

export default addCountry;
